import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true, // this will log errors with loading translations
    fallbackLng: 'en',
    //lng: 'en',
    resources: {
      "en": {
        translations: {
          description: {
            title: "Sell Your Phone In 3 Steps",
            title1: "Upgrade to your Dream Phone",
            description: "Selling your Phone Has never been easier",
            description1: "Your dream phone is one click away",
            repair: "Repair",
            sell: "Sell Now",
            select_model:'Select Model',
            color:'Color',
            select_brand:'Select Brand',
            buy: "Buy now",
            image: "/assets/images/landing-page/phone-01.webp",
            image1: "/assets/images/landing-page/phone-02.webp",
            top_brand_title:"Top Brands",
            what_Customers_Have_To_Say:"What Our Customers Have To Say",
            find_badili_store:"Find Badili Stores Near You",
            footer_bottom_desc:"We’re a leading re-commerce for renewed devices. Our mission is to stop e-waste giving them a second chance to shine.Be a part of our mission to make a difference!",
            banner_expert_Checked:"Expert Checked",
            banner_months_Warranty:"12 Months Warranty",
            banner_reduces_e_waste:"Reduces e-waste",
            banner_Service_Centers:"80+ Service Centers",
            view_all_tz:"View all",
            
            footer_menu_about_title:"About",
            footer_menu_about_about_us:"About us",
            footer_menu_Buy_Phone_from_Us:"Buy Phone from Us",
            footer_menu_badili_Stores:"Badili Stores",
            footer_menu_about_careers:"Careers",
            footer_menu_Help:"Help",
            footer_menu_how_to_Become_A_Dealer:"How to Become A Dealer",
            footer_menu_Warranty:"Warranty",
            footer_menu_Contact_Us:"Contact Us",
            footer_menu_Post_Testimonial:"Post Testimonial",
            footer_menu_Legal:"Legal",
            footer_menu_Privacy_Policy:"Privacy Policy",
            footer_menu_Terms_and_Conditions:"Terms and Conditions",
            footer_menu_Return_Policy:"Return Policy",
            footer_menu_Social:"Social",
            testimonial_tz:"Testimonial",

            tz_home_image1: '/assets/images/landing-page/ad1.png',
            tz_home_image2: '/assets/images/landing-page/add1.png',
            tz_home_image3: '/assets/images/landing-page/add2.png',
            tz_home_image4: '/assets/images/landing-page/add2.png',

            repair_header:'Repair your phone',
            sell_header:'Sell your phone',
            sell_title:'Sell',
            login:'Sign In',
            warranty:' Certified Pre-Loved SmartPhones | 12 Months Warranty',
            faq:'Frequently Asked Questions',
            stores:'Exclusive stores',
            badili_title:'A little about badili',
            quality:"Quality Guaranteed",
            quality1:'Affordability',
            quality3:"Transparency & Legitimacy",
            quality2:"Customer Care",
            detail:'100% functional phones.Free 30-day warranty',
            detail1:"Serious about money? Our fine selecton and prices will delight you",
            detail2:"All phones are original and comply with the latest regulations",
            detail3:'We always give you the best shopping experience',
            offers:"starting from",
            bestseller_heading:"Explore Our Best Sellers",
            product_property:"Our Products Condition",
            property1:"As Good As New!",
            property1_detail:"Excellent",
            property1_title:"What to expect?",
            property1_body:" Screen and body are in very good condition",
            property2:"Just Right!",
            property2_detail:"Good",
            property2_body:" Body has a few microscratches that are barely noticeable from far",
            property3:"Value For Money!",
            property3_detail:"Fair",
            property3_body:" Body and screen has a few microscratches that are barely noticeable from far",
            property4:"Beyond Economic Repair!",
            property4_detail:"For parts",
            property4_body:" Body and screen has a few microscratches that are barely noticeable from far",

            faq_q1:"What criteria did you use to evaluate my phone?",
            faq_a1:"Our evaluation is based on an algorithm that values your phone according to its current physical & functional condition.",
            faq_q2:"What happens if my phone model/variant is not listed?",
            faq_a2:"The device may not be elligible for purchase since we only buy devices whose year of release is 2018 and later.",
            faq_q3:"Which phone brands are accepted for trade in?",
            faq_a3:"We accept iPhone, Samsung, Infinix, Realme, Vivo, Redmi and Techno brands.",
            faq_q4:"Why do I have to sign the mobile phone purchasing agreement and the affidavit?",
            faq_a4:"Purchasing document represents willingness to sell your device and affidavit is a legal binding document for the device",
            faq_q5:"Why do I have to reset my device after trading in?",
            faq_a5:"To clear your personal data on the device.",
            faq_q6:"How long does it take to trade in/sell my device?",
            faq_a6:"'It takes about 8-10 minutes to trade in your device and another 10 minutes to receive payment.",
            faq_q7:"What happens to my private and confidential information after signing the documents? ",
            faq_a7:"Customer information is private and confidential and will not be disclosed outside of business.",
            buy_back_step1:"Check Price",
            buy_back_step2:"Schedule Pickup",
            buy_back_step3:"Get Paid",
            buy_back_detail1:"Tailor made by our advanced Ai based on your device condition, just for you",
            buy_back_detail2:" Book a free pickup from your home or work at a timeslot as per your convenience",
            buy_back_detail3:"Instant & secure payments as soon as device is picked up",
            marketing:"Why Sell Us Your Phone",

            marketing_title1:"Best Price",
            marketing_title2:"Instant Payment",
            marketing_title3:"Free Doorstep pickup",
            marketing_title4:"Safe, Secure & Convenient",

            marketing_detail1:"Get the best price for your old device",
            marketing_detail2:"Fast and secure payments upon pickup",
            marketing_detail3:"Just a click away from your home or office",
            marketing_detail4:"Have a quick and hassle-free experience with us",
            slogan:"Africa's First and Largest Online Mobile Expert",

            

            about: `Introducing Badili: Africa's pioneering re-commerce platform for refurbished smartphones. Our mission is to empower every African with affordable, high-quality smartphones, building accessibility and trust in pre-owned devices. Choose from our certified pre-owned smartphones or seamlessly trade in your current device. Enjoy satisfaction at a fraction of the cost with a 12-month warranty. Our commitment extends beyond transactions – we're here for the long run, providing repairs and support. Join us and thousands of other Africans in the Badili family, where affordability meets quality!`
          }
        }
      },
      "sw": {
        translations: {
          description: {
            title: "Uza Simu yako kwa Hatua 3",
            title1: "Boresha Ndoto yako ya Simu",
            description: "Kubadilishana Simu yako Haijawahi kuwa rahisi",
            description1: "Simu yako ya ndoto ni mbofyo mmoja mbali",
            repair: "Ukarabati",
            repair_header:'Karabati simu yako',
            sell_header:'Uza simu yako',
            sell_title:'Uza',
            sell: "Uza sasa",
            select_model:'Chagua Mfano',
            color:'Rangi',
            select_brand:'Chagua Chapa',
            buy: "Nunua Sasa",
            image: "/assets/images/landing-page/phone-02.webp",
            image1: "/assets/images/landing-page/phone-01.webp",
            top_brand_title:"Bidhaa za Juu",
            what_Customers_Have_To_Say:"Nini Wateja Wetu Wanapaswa Kusema",
            find_badili_store:"Tafuta Maduka ya Badili yaliyo karibu nawe",
            footer_bottom_desc:"Tunaongoza katika uuzaji upya wa vifaa vilivyosasishwa. Dhamira yetu ni kukomesha e-waste kuwapa nafasi ya pili ya kung'aa.Kuwa sehemu ya dhamira yetu ya kuleta mabadiliko!",
            banner_expert_Checked:"Mtaalam Amekaguliwa",
            banner_months_Warranty:"Udhamini wa Miezi 12",
            banner_reduces_e_waste:"Hupunguza taka za kielektroniki",
            banner_Service_Centers:"80+ Vituo vya Huduma",
            view_all_tz:"Tazama zote",

            footer_menu_about_title:"Kuhusu",
            footer_menu_about_about_us:"Kuhusu sisi",
            footer_menu_Buy_Phone_from_Us:"Nunua Simu kutoka Kwetu",
            footer_menu_badili_Stores:"Maduka ya Badili",
            footer_menu_about_careers:"Ajira",
            footer_menu_Help:"Msaada",
            footer_menu_how_to_Become_A_Dealer:"Jinsi ya kuwa Mfanyabiashara",
            footer_menu_Warranty:"Udhamini",
            footer_menu_Contact_Us:"Wasiliana nasi",
            footer_menu_Post_Testimonial:"Chapisha Ushuhuda",
            footer_menu_Legal:"Kisheria",
            footer_menu_Privacy_Policy:"Sera ya Faragha",
            footer_menu_Terms_and_Conditions:"Sheria na Masharti",
            footer_menu_Return_Policy:"Sera ya Kurudisha",
            footer_menu_Social:"Kijamii",
            testimonial_tz:"Ushuhuda",

            tz_home_image1: '/assets/images/landing-page/TzHome1.png',
            tz_home_image2: '/assets/images/landing-page/TzHome2.png',
            tz_home_image3: '/assets/images/landing-page/TzHome3.png',
            tz_home_image4: '/assets/images/landing-page/TzHome4.png',

            login:'Ingia',
            warranty:'Simu mahiri Zilizoidhinishwa Zilizopendwa Awali | Udhamini wa Miezi 12',
            faq:'Maswali yako yamejibiwa',
            stores:'Maduka ya kipekee',
            badili_title:'Kuhusu badili',
            quality:"Imehakikishwa Ubora",
            quality1:'Uwezo wa kumudu',
            quality2:"Uwazi na Uhalali",
            quality3:"Huduma kwa Wateja",
            detail:'Simu zinazofanya kazi 100%. Bila malipo kwa siku 30 dhamana',
            detail1:"Serious kuhusu pesa? Faini yetu kuchagua na bei zitakufurahisha",
            detail2:"Simu zote ni asili na zinatii kanuni za hivi punde",
            detail3:"Daima tunakupa uzoefu bora wa ununuzi",
            offers:"Kuanzia",
            bestseller_heading:"Gundua Wauzaji Wetu Bora Zaidi",
            product_property:"Hali ya Bidhaa zetu",
            property1:"Nzuri Kama Mpya!",
            property1_detail:"Bora kabisa",
            property1_title:"Nini cha Kutarajia?",
            property1_body:"Skrini na mwili viko katika hali nzuri sana",
            property2:"Sawa tu!",
            property2_detail:"Nzuri",
            property2_body:"Mwili una mikwaruzo michache ambayo haionekani kwa mbali",
            property3:"Thamani ya pesa!",
            property3_detail:"Haki",
            property3_body:"Mwili na skrini ina mikwaruzo michache ambayo haionekani kwa urahisi kutoka mbali",
            property4:"Zaidi ya Matengenezo ya Kiuchumi!",
            property4_detail:"Kwa sehemu",
            property4_body:" Inauzwa kwa bei iliyopunguzwa sana. Inaweza kutumika kwa sehemu",

            faq_q1:"Umetumia vigezo gani kutathmini simu yangu?",
            faq_a1:"Tathmini yetu inategemea kanuni inayothamini simu yako kulingana na hali yake ya sasa ya kimwili na kiutendaji.",
            faq_q2:"Nini kitatokea ikiwa modeli/lahaja ya simu yangu haijaorodheshwa?",
            faq_a2:"Huenda kifaa kisistahiki kununuliwa kwa vile sisi hununua tu vifaa ambavyo mwaka wa kutolewa ni 2018 na baadaye.",
            faq_q3:"Ni chapa gani za simu zinazokubaliwa kufanya biashara?",
            faq_a3:"Tunakubali chapa za iPhone, Samsung, Infinix, Realme, Vivo, Redmi na Techno",
            faq_q4:"Kwa nini ni lazima nitie sahihi mkataba wa ununuzi wa simu ya mkononi na hati ya kiapo?",
            faq_a4:"Hati ya ununuzi inawakilisha nia ya kuuza kifaa chako na hati ya kiapo ni hati ya kisheria ya kifaa.",
            faq_q5:"Kwa nini ni lazima niweke upya kifaa changu baada ya kufanya biashara?",
            faq_a5:"Ili kufuta data yako ya kibinafsi kwenye kifaa.",
            faq_q6:"Je, inachukua muda gani kufanya biashara/kuuza kifaa changu?",
            faq_a6:"Inachukua kama dakika 8-10 kufanya biashara na kifaa chako na dakika nyingine 10 kupokea malipo.",
            faq_q7:"Je, ni nini kitatokea kwa taarifa zangu za faragha na za siri baada ya kusaini hati?",
            faq_a7:"Maelezo ya mteja ni ya faragha na ya siri na hayatafichuliwa nje ya biashara.",
            buy_back_step1:"Angalia Bei",
            buy_back_step2:"Panga Kuchukua",
            buy_back_step3:"Lipwa",
            buy_back_detail1:"Iliyoundwa na Ai yetu ya juu kulingana na hali ya kifaa chako, kwa ajili yako tu",
            buy_back_detail2:"Weka nafasi ya kuchukua bila malipo kutoka nyumbani kwako au kazini kwenye nyakati kulingana na urahisi wako",
            buy_back_detail3:"Malipo ya papo hapo na salama mara tu kifaa kinapochukuliwa",
            marketing:"Kwanini Utuuzie Simu Yako",

            marketing_title1:"Bei Bora",
            marketing_title2:"Pesa ya Papo hapo",
            marketing_title3:"Chukua Mlango Bila Malipo",
            marketing_title4:"Salama, Salama & Rahisi",


            marketing_detail1:"Pata bei nzuri zaidi ya kifaa chako cha zamani",
            marketing_detail2:"Malipo ya haraka na salama wakati wa kuchukua",
            marketing_detail3:"Bofya tu mbali na nyumba yako au ofisi",
            marketing_detail4:"Pata matumizi ya haraka na bila usumbufu nasi",
            slogan:"Mtaalamu wa Kwanza na Mkubwa Zaidi wa Simu za Mkononi barani Afrika",

            about: `Tunakuletea Badili: Jukwaa kuu la Afrika la kufanya biashara upya kwa simu mahiri zilizorekebishwa. Dhamira yetu ni kuwezesha kila Mwafrika kwa bei nafuu, simu mahiri za ubora wa juu, ufikiaji wa kujenga na kuamini vifaa vinavyomilikiwa awali. Chagua kutoka kwa simu zetu mahiri zilizoidhinishwa zinazomilikiwa awali au ufanye biashara bila mshono katika kifaa chako cha sasa. Furahia kuridhika kwa sehemu ya gharama na udhamini wa miezi 12. Ahadi yetu inaenea zaidi ya miamala - tuko hapa kwa muda mrefu, tukitoa matengenezo na usaidizi. Jiunge nasi na maelfu ya Waafrika wengine katika familia ya Badili, ambapo uwezo wa kumudu unakidhi ubora! `
          }
        }
      }





      // en: {
      //     translations: require('./locales/en/translations.json'),
      // },
      // lg: {
      //     translations: require('./locales/lg/translations.json'),
      // },
    },
    ns: ['translations'],
    defaultNS: 'translations',
  })

i18n.languages = ['en', 'lg']

export default i18n
